import React, { Component } from 'react'
import injectSheet from 'react-jss'
import styles from './resolution.styles'
import Alert from 'pobble-components/dist/alert'
import { ModalFooter } from 'pobble-components/dist/modal'
import Button from 'pobble-components/dist/button'
import PobbleLink from 'pobble-components/dist/pobble-link'
import { PobbleAvatar } from 'pobble-components/dist/pobble-avatar'
import FormRadio from 'pobble-components/dist/form-elements/form-radio'
import Autocomplete from 'react-autocomplete'
import classNames from 'classnames'

class Resolution extends Component {
  constructor(props) {
    super(props)
    this.state = {
      status: 'retiring',
      value: '',
      selectedStudent: null
    }
  }

  render() {
    const {
      classes,
      similarStudentResolved,
      studentName,
      studentDay,
      studentMonth,
      workCount,
      groups,
      remainingStudents,
      unmatchingStudents,
      schoolId,
      studentId,
      processing,
      onResolve,
      onRetire
    } = this.props
    return (
      <div className={classes.container}>
        <div className={classes.remaining}>
          <strong>{remainingStudents}</strong> student
          {remainingStudents > 1 ? 's' : ''} left
        </div>
        {similarStudentResolved && (
          <Alert type="info" className={classes.alert}>
            It appears that this pupil had previously been entered twice.
            Currently, this pupil already exists in Pobble. You can safely
            retire this record. In case this leads to unexpected results, please
            contact Pobble at{' '}
            <PobbleLink href="mailto:hello@pobble.com">
              hello@pobble.com
            </PobbleLink>
          </Alert>
        )}
        <div className={classes.content}>
          <div className={classes.head}>
            <PobbleAvatar name={studentName} className={classes.avatar} />
            <p>{studentName} will be retired from Pobble</p>
          </div>
          <ul className={classes.details}>
            <li>
              Date of birth: {studentDay}/{studentMonth}
            </li>
            <li>Groups: {groups || '-'}</li>
            <li>Works: {workCount}</li>
          </ul>
          <div
            className={classNames(classes.selection, {
              [classes.processing]: processing
            })}>
            <div className={classes.choice}>
              <FormRadio
                name="status"
                id="retiringStudent"
                onChange={() => this.setState({ status: 'retiring' })}
                checked={this.state.status === 'retiring'}
              />
              <label htmlFor="retiringStudent">
                This is correct. {studentName} left the school.
              </label>
            </div>
            <div className={classes.choice}>
              <FormRadio
                name="status"
                id="matchingStudent"
                onChange={() => this.setState({ status: 'matching' })}
                checked={this.state.status === 'matching'}
                disabled={unmatchingStudents && !unmatchingStudents.length}
              />
              <label htmlFor="matchingStudent">
                This is incorrect. {studentName} is still at the school.
                {unmatchingStudents &&
                  !unmatchingStudents.length && (
                    <strong> All students matched</strong>
                  )}
              </label>
            </div>
            {this.state.status === 'matching' && (
              <Autocomplete
                inputProps={{
                  id: 'students-autocomplete',
                  className: classes.field,
                  placeholder: 'Search for the matching pupil'
                }}
                wrapperStyle={{ position: 'relative' }}
                value={this.state.value}
                items={unmatchingStudents}
                getItemValue={item => item.full_name}
                onSelect={(value, item) =>
                  this.setState({
                    value,
                    selectedStudent: item
                  })
                }
                onChange={(event, value) =>
                  this.setState({ value, selectedStudent: null })
                }
                renderMenu={children => (
                  <div className={classes.menu}>{children}</div>
                )}
                renderItem={(item, isHighlighted) => (
                  <div
                    className={classNames(classes.item, {
                      [classes.highlighted]: isHighlighted
                    })}
                    key={item.id}>
                    {item.full_name}
                  </div>
                )}
              />
            )}
          </div>
        </div>
        <ModalFooter className={classes.footer}>
          {this.state.status === 'retiring' && (
            <Button
              tall
              disabled={processing}
              action={() => onRetire(studentId, schoolId)}>
              {!processing ? 'Next' : 'Processing...'}
            </Button>
          )}
          {this.state.status === 'matching' && (
            <Button
              tall
              action={() =>
                onResolve(
                  schoolId,
                  studentId,
                  this.state.selectedStudent.id
                ).then(() =>
                  this.setState({
                    status: 'retiring',
                    value: '',
                    selectedStudent: null
                  })
                )
              }
              disabled={
                !(
                  this.state.selectedStudent && this.state.selectedStudent.id
                ) || processing
              }>
              {!processing ? 'Next' : 'Processing...'}
            </Button>
          )}
        </ModalFooter>
      </div>
    )
  }
}

export default injectSheet(styles)(Resolution)
